export const USERFLOW_ID =
  window.location.hostname === 'app.qualisflow.com'
    ? 'ct_q4r4ityjmfdrxpwu2b4b3gb3wu'
    : 'ct_i5jaz5iadbcorpsmv3yeuqfxsy'

export const WELCOME_TO_QFLOW_CHECKLIST_ID =
  '8fb40cee-52fc-49be-a752-4da559d73dc0'
